<template>
  <div
    id="details"
    class="tab-pane block pb-4 md:pt-8"
    role="tabpanel"
  >
    <div
      v-if="trip.special_videointroduction?.length"
      class="md:mt-8 w-full mb-12 md:mb-16 print-hidden"
    >
      <LazyMediaLogoCard
        v-for="(videoIntroduction, idx) in specialVideoIntroductions"
        :key="idx"
        :logo="videoIntroduction.logo"
        :title="videoIntroduction.quote"
        :title-by="videoIntroduction.quote_by"
        :text="videoIntroduction.text"
        :media="videoIntroduction.media"
      />
    </div>
    <div
      class="mt-6 md:mt-4 w-full"
    >
      <TripIntro
        :active-itinerary="activeItinerary"
        :itineraries="itineraries"
        :trip="trip"
        :has-map-preview="hasMapPreview"
        @open-map="openMap"
      />
    </div>
    <div
      :class="itineraries.length > 1 || trip.videointroduction?.length || !!trip.departure_info ? 'py-12' : 'pb-12'"
    >
      <LazyTripVideoIntroductions
        v-if="trip.videointroduction?.length"
        :video-introductions="trip.videointroduction"
        class="mt-2 md:mt-4"
      />
      <LazyDepartureInfo
        v-if="!!trip.departure_info"
        class="mt-4 md:mt-4 my-print-0 w-full"
        :trip="trip"
      />
    </div>
    <TripItinerary
      class="w-full"
      :active-itinerary="activeItinerary"
      :active-itinerary-index="activeItineraryIndex"
      :itineraries="itineraries"
      :active-marker="activeMarker"
      :is-destination="isDestination"
      @set-marker="setMarker"
      @open-map="openMap"
      @select-itinerary="setActiveItinerary"
    />
    <TravelerPictures
      class="w-full mt-20 print-hidden"
      :trip-type-id="trip.id"
      size="500x500"
      fit="c"
    />
    <div class="mt-24 md:mt-12 w-full">
      <LazyOtherInfo :trip="trip" />
    </div>
    <TripDetailsSingleFinderLink class="mt-4" />
    <div
      v-if="trip.reviews_average"
      class="mt-8 w-full print-hidden"
    >
      <LazyReviews
        :trip="trip"
        :latestreviews="latestreviews"
      />
    </div>
    <LazyMarkedMapModal
      v-if="mapOpen"
      :trip="trip"
      :map-open="mapOpen"
      :active-itinerary="activeItinerary"
      :active-marker="activeMarker"
      :is-destination="isDestination"
      @set-marker="setMarker"
      @open-map="openMap"
      @close-map="closeMap"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  itineraries: {
    type: Array,
    required: true,
  },
  trip: {
    type: Object,
    required: true,
  },
  suggested: {
    type: Array,
    default: () => [],
  },
  calendar: {
    type: Object,
    default: () => ({}),
  },
  isDestination: {
    type: Boolean,
    default: false,
  },
  latestreviews: {
    type: Array,
    default: () => [],
  },
})

const activeMarker = ref(null)
const activeItineraryIndex = ref(0)
const mapOpen = ref(false)

const activeItinerary = computed(() => {
  return props.itineraries?.[activeItineraryIndex.value] || props.itineraries?.[0]
})

const hasMapPreview = computed(() => {
  return isValidMap(activeItinerary.value?.overviewmap)
})

const specialVideoIntroductions = computed(() => {
  return props.trip?.special_videointroduction?.map(videoIntroduction => ({
    ...videoIntroduction,
    logo: {
      url: videoIntroduction.cloudinary_logo,
    },
    media: {
      mediatype: 'video',
      type: videoIntroduction.movie_type,
      location: videoIntroduction.movie_id,
      customThumbnail: {
        url: videoIntroduction.cloudinary_image,
      },
    },
  }))
})

onMounted(() => {
  activeItineraryIndex.value = props.itineraries.findIndex(obj => obj.mainitinerary === true)
})

const setMarker = (i) => {
  activeMarker.value = i
}

const openMap = (day) => {
  mapOpen.value = true
  setMarker(day)
}

const closeMap = () => {
  activeMarker.value = null
  mapOpen.value = false
}

const isValidMap = (map) => {
  if (!map) {
    return false
  }

  if (!map.thumb_bounds.lat_center && !map.thumb_bounds.lng_center && !map.thumb_bounds.zoom) {
    return false
  }

  return true
}

const setActiveItinerary = (itineraryIndex) => {
  activeMarker.value = null
  activeItineraryIndex.value = parseInt(itineraryIndex)
}
</script>
